import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent, MatDialogRef
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MatSelectModule } from "@angular/material/select";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgForOf, NgIf } from "@angular/common";
import { MatCheckbox } from "@angular/material/checkbox";
import { TimeslotRow, TimeslotsProvider, WeekForDuplication } from "../../providers/timeslots-provider";
import { Observable } from "rxjs";
import { Organization } from "../../../common/models/organization";
import { Agenda } from "../../../common/models/agenda";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'calendar-duplicate-form-modal',
  templateUrl: './calendar-duplicate-form-modal.html',
  styleUrls: ['./calendar-duplicate-form-modal.scss'],
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    TranslateModule,
    FormsModule,
    MatSelectModule,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    MatCheckbox,
  ],
  standalone: true,
})
export class CalendarDuplicateFormModalComponent {
  public organization: Organization;
  public agenda: Agenda;
  public timeslotRowsToDuplicate: TimeslotRow[];
  public weeks: WeekForDuplication[] = [];
  public isOverrideEnabled: boolean = false;
  public duplicationForm: FormGroup;

  public isSubmitting: boolean = false;


  constructor(
    private fb: FormBuilder,
    private utils: UtilsProvider,
    private translater: TranslateService,
    private toaster: MatSnackBar,
    private timeslotsProvider: TimeslotsProvider,
    public dialog: MatDialogRef<CalendarDuplicateFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (!data || !data.timeslotRowsToDuplicate) {
      throw new Error("FATAL : Missing data to dialog");
    }
    if (!data.organization || !data.agenda) {
      throw new Error("FATAL : Missing organization or agenda to duplicate timeslots");
    }
    this.timeslotRowsToDuplicate = data.timeslotRowsToDuplicate;
    this.agenda = data.agenda;
    this.organization = data.organization;

    const today = new Date();
    const toDate: Date = new Date(today.getFullYear() + 1, today.getMonth(), today.getDay());
    const weeks: WeekForDuplication[] = [];
    while (today.getTime() < toDate.getTime()) {
      weeks.push({
        name: this.utils.getWeekNumber(today) + " - " + today.getFullYear(),
        number: this.utils.getWeekNumber(today),
        fromDate: this.utils.DateToYmd(this.utils.firstDayOfWeek(today))
      });
      today.setDate(today.getDate() + 7);
    }
    this.weeks = weeks;

    this.duplicationForm = this.fb.group({
      weeks: new FormControl([],[Validators.required]),
      isOverrideEnabled: new FormControl(this.isOverrideEnabled, []),
    });
  }

  public onConfirmClicked() : any {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    const selectedWeeks = this.duplicationForm.value.weeks; // This will now be an array of selected week numbers
    this.timeslotsProvider.duplicateTimeslotsOnWeeks({
      organization: this.organization,
      agenda: this.agenda,
      timeslotRows: this.timeslotRowsToDuplicate,
      weeks: selectedWeeks,
      overwriteOverlapping: this.isOverrideEnabled,
    }).subscribe({
      next: () => {
        this.dialog.close({success: true});
        this.isSubmitting = false;
      },
      error: (error) => {
        this.isSubmitting = false;
        switch (error.status) {
          case 422:
            this.toaster.open(this.translater.instant('Session_duplication_conflict'), '',{duration: 5000});
            break;
          default:
            this.dialog.close({success: false, message: error.status ?? 500});
            break;
        }
      }
    });
  }

  public onOverrideSelectionChange() {
    this.isOverrideEnabled = !this.isOverrideEnabled;
  }

  get f() {
    return this.duplicationForm.controls;
  }

}


